import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Input, Select, InputNumber } from "antd";
import axios from "../../../services/axiosConfig";
import Helper from "../../../services/Helper";

const CourierAddress = ({ show, close, details }) => {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const [update, setUpdate] = useState(false);

  useEffect(() => {
    form.setFieldsValue({
      name: details?.address?.name,
      address: details?.address?.address,
      city: details?.address?.city,
      zip: details?.address?.zip,
      phone: details?.address?.phone,
    });
    details?.address?.name && setUpdate(true);
  }, [show]);

  const handleCancel = () => {
    close();
  };

  const onFinish = async (values) => {
    if (update) {
      const data = await axios
        .post("/update-order-img", {
          ordersId: details.id,
          address: values,
        })
        .catch((error) => {
          Helper.ErrorHanlder(error);
        });
      if (data && data.data) close(data);
    } else {
      const data = await axios
        .patch("/update-courier-address", {
          id: details.id,
          address: values,
          details,
        })
        .catch((error) => {
          Helper.ErrorHanlder(error);
        });
      if (data && data.data) close(data);
    }
  };

  return (
    <>
      <Modal title="" open={show} onCancel={handleCancel} footer={false}>
        <Form layout={"vertical"} form={form} onFinish={onFinish}>
          <Form.Item
            label="Full Name"
            name="name"
            rules={[
              {
                required: true,
                message: "Name is required",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Address"
            name="address"
            rules={[
              {
                required: true,
                message: "Address is required",
              },
            ]}
          >
            <TextArea
              // value={value}
              // onChange={(e) => setValue(e.target.value)}
              autoSize={{
                minRows: 3,
                maxRows: 5,
              }}
            />
          </Form.Item>
          <Form.Item
            label="City"
            name="city"
            rules={[
              {
                required: true,
                message: "City is required",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Zip Code"
            name="zip"
            rules={[
              {
                required: true,
                message: "Zip Code is required",
              },
            ]}
          >
            <InputNumber className="w-100" />
          </Form.Item>
          <Form.Item
            label="Phone No"
            name="phone"
            rules={[
              {
                required: true,
                message: "Phone No is required",
              },
            ]}
          >
            <InputNumber className="w-100" />
          </Form.Item>
          <Form.Item className="popup-submit">
            <Button className="popup-cancel-btn" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              className="popup-submit-btn"
            >
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default CourierAddress;
